// semeia-disable-reexport
import ActivityRecovery from "./activity-recovery";
import AmbulatoryProcedure from "./ambulatory-procedure";
import ArticularPainIssue from "./articular-pain-issue";
import ArticularPainLevel from "./articular-pain-level";
import ArticularPainLocation from "./articular-pain-location";
import ArticularPainTreatmentEfficient from "./articular-pain-treatment-efficient";
import AttendantForReturn from "./attendant-for-return";
import BleedingOnWound from "./bleeding-on-wound";
import BoughtPainkillersAndAntinauseant from "./bought-painkillers-and-antinauseant";
import Breath from "./breath";
import BreathIssue from "./breath-issue";
import CalfPain from "./calf-pain";
import Constipation from "./constipation";
import ConstipationIssue from "./constipation-issue";
import ConstipationTreatmentEfficient from "./constipation-treatment-efficient";
import Cortisone from "./cortisone";
import CortisoneDosageGt20 from "./cortisone-dosage-gt20";
import Cough from "./cough";
import CoughIssue from "./cough-issue";
import CurrentWeight from "./current-weight";
import DermatologicalIssue from "./dermatological-issue";
import DermatologicalTreatmentEfficient from "./dermatological-treatment-efficient";
import Diarrhea from "./diarrhea";
import DiarrheaIssue from "./diarrhea-issue";
import DiastolicBloodPressure from "./diastolic-blood-pressure";
import DifficultiesToUrinate from "./difficulties-to-urinate";
import DigestiveRecovery from "./digestive-recovery";
import EatingRecovery from "./eating-recovery";
import EditionForm from "./edition-form";
import Fatigue from "./fatigue";
import FatigueIssue from "./fatigue-issue";
import ItchingIssue from "./itching-issue";
import ItchingLocation from "./itching-location";
import MuscularPainIssue from "./muscular-pain-issue";
import MuscularPainLevel from "./muscular-pain-level";
import MuscularPainLocation from "./muscular-pain-location";
import MuscularPainTreatmentEfficient from "./muscular-pain-treatment-efficient";
import NauseaOrVomiting from "./nausea-or-vomiting";
import NauseaVomiting from "./nausea-vomiting";
import NauseaVomitingIssue from "./nausea-vomiting-issue";
import OtherPainIssue from "./other-pain-issue";
import OtherPainLocation from "./other-pain-location";
import OtherPainTreatmentEfficient from "./other-pain-treatment-efficient";
import PacFlowing from "./pac-flowing";
import PacHealing from "./pac-healing";
import PacInflammatory from "./pac-inflammatory";
import PacPainful from "./pac-painful";
import Pain from "./pain";
import PainIssue from "./pain-issue";
import PainSinceBackHome from "./pain-since-back-home";
import Pulse from "./pulse";
import Radiotherapy from "./radiotherapy";
import SkinRashIssue from "./skin-rash-issue";
import SkinRashLocation from "./skin-rash-location";
import SystolicBloodPressure from "./systolic-blood-pressure";
import Temperature from "./temperature";
import TemperatureIssue from "./temperature-issue";
import TemperatureLevel from "./temperature-level";
import TrustPersonSurveyFilled from "./trust-person-survey-filled";
import UsualTreatmentGuidelines from "./usual-treatment-guidelines";
import WeightLoss from "./weight-loss";
import WeightLossIssue from "./weight-loss-issue";
import WoundFlow from "./wound-flow";
import WoundInflammation from "./wound-inflammation";
const Sections = {
  "activity-recovery": ActivityRecovery,
  "ambulatory-procedure": AmbulatoryProcedure,
  "articular-pain-issue": ArticularPainIssue,
  "articular-pain-level": ArticularPainLevel,
  "articular-pain-location": ArticularPainLocation,
  "articular-pain-treatment-efficient": ArticularPainTreatmentEfficient,
  "attendant-for-return": AttendantForReturn,
  "bleeding-on-wound": BleedingOnWound,
  "bought-painkillers-and-antinauseant": BoughtPainkillersAndAntinauseant,
  breath: Breath,
  "breath-issue": BreathIssue,
  "calf-pain": CalfPain,
  constipation: Constipation,
  "constipation-issue": ConstipationIssue,
  "constipation-treatment-efficient": ConstipationTreatmentEfficient,
  cortisone: Cortisone,
  "cortisone-dosage-gt20": CortisoneDosageGt20,
  cough: Cough,
  "cough-issue": CoughIssue,
  "current-weight": CurrentWeight,
  "dermatological-issue": DermatologicalIssue,
  "dermatological-treatment-efficient": DermatologicalTreatmentEfficient,
  diarrhea: Diarrhea,
  "diarrhea-issue": DiarrheaIssue,
  "diastolic-blood-pressure": DiastolicBloodPressure,
  "difficulties-to-urinate": DifficultiesToUrinate,
  "digestive-recovery": DigestiveRecovery,
  "edition-form": EditionForm,
  "eating-recovery": EatingRecovery,
  fatigue: Fatigue,
  "fatigue-issue": FatigueIssue,
  "itching-issue": ItchingIssue,
  "itching-location": ItchingLocation,
  "muscular-pain-issue": MuscularPainIssue,
  "muscular-pain-level": MuscularPainLevel,
  "muscular-pain-location": MuscularPainLocation,
  "muscular-pain-treatment-efficient": MuscularPainTreatmentEfficient,
  "nausea-or-vomiting": NauseaOrVomiting,
  "nausea-vomiting": NauseaVomiting,
  "nausea-vomiting-issue": NauseaVomitingIssue,
  "other-pain-issue": OtherPainIssue,
  "other-pain-location": OtherPainLocation,
  "other-pain-treatment-efficient": OtherPainTreatmentEfficient,
  "pac-flowing": PacFlowing,
  "pac-healing": PacHealing,
  "pac-inflammatory": PacInflammatory,
  "pac-painful": PacPainful,
  pain: Pain,
  "pain-issue": PainIssue,
  "pain-since-back-home": PainSinceBackHome,
  pulse: Pulse,
  radiotherapy: Radiotherapy,
  "skin-rash-issue": SkinRashIssue,
  "skin-rash-location": SkinRashLocation,
  "systolic-blood-pressure": SystolicBloodPressure,
  temperature: Temperature,
  "temperature-level": TemperatureLevel,
  "temperature-issue": TemperatureIssue,
  "trust-person-survey-filled": TrustPersonSurveyFilled,
  "usual-treatment-guidelines": UsualTreatmentGuidelines,
  "weight-loss": WeightLoss,
  "weight-loss-issue": WeightLossIssue,
  "wound-flow": WoundFlow,
  "wound-inflammation": WoundInflammation
};
export default Sections;